/** Portalierte Layer (z.B. das DescriptionAutocomplete-Dropdown, das an
 *  document.body hängt) liegen DOM-technisch AUSSERHALB des Anchor-Containers
 *  handgebauter Popovers. Ein globaler Outside-Click-Handler (pointerdown,
 *  capture) wertet sie sonst als „außen" und schließt das Popover, bevor der
 *  click das Ziel erreicht — der Pick käme nie an (Ticket: Stoppuhr-Vorschlag).
 *  Solche Layer markieren sich mit diesem Attribut und werden vom Dismiss
 *  ausgenommen. */
export const OUTSIDE_CLICK_EXEMPT_ATTR = 'data-outside-click-exempt'

const EXEMPT_SELECTOR = `[${OUTSIDE_CLICK_EXEMPT_ATTR}]`

/** Strukturtypen statt DOM-Typen, damit der Helper in der node-Testumgebung
 *  ohne jsdom testbar bleibt (vitest.config.ts: environment 'node'). */
type ClosestLike = { closest(selector: string): unknown }
type ContainsLike = { contains(node: unknown): boolean }

/** Entscheidet für einen window-pointerdown (capture), ob ein handgebautes
 *  Anchor-Popover schließen soll: nicht bei Klicks im Container und nicht in
 *  exempt-markierten Portal-Layern; sonst ja (inkl. fehlendem Ziel/Container —
 *  Bestandsverhalten des bisherigen contains-Checks). */
export function shouldDismissOnOutsidePointer(
  target: ClosestLike | null,
  container: ContainsLike | null | undefined,
): boolean {
  if (target?.closest(EXEMPT_SELECTOR)) return false
  return !container?.contains(target)
}
